import { render } from "./customer.html?vue&type=template&id=6952ed57&scoped=true&external"
import script from "./customer.vue?vue&type=script&lang=js"
export * from "./customer.vue?vue&type=script&lang=js"

import "./customer.vue?vue&type=style&index=0&id=6952ed57&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6952ed57"]])

export default __exports__